import { Section } from '@tracklib/kit'
import styles from './importantblock.css'

type ImportantBlockProps = {
  value: {
    text: string
  }
}

const ImportantBlock = ({ value: { text } }: ImportantBlockProps): JSX.Element => (
  <Section size="small">
    <p className={styles.wrapper}>{text}</p>
  </Section>
)

export default ImportantBlock
